import React, { useState, useEffect, useRef, useMemo } from "react";

import { ProgressBar } from "react-bootstrap";
import { base, s3base } from "api.js";
// import { Checkbox } from '@mui/material';
import Sound from 'react-sound';
// core components
import "components/custom.css";
// import ReactHtmlParser from 'react-html-parser';
import reactStringReplace from 'react-string-replace';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

const ListeningBlank = (props) => {
  const inputRef = useRef(null);
  const intervalIdRef = useRef(0);
  const intervalId2Ref = useRef(0);
  const recordIdRef = useRef(0);

  const [state, setState] = useState({
    isRecording: false,
    blobURL: '',
    isBlocked: false,
    question: "",
    secondCount: 10,
    recordCount: 0,
    recordId: 1,
    intervalId: 0,
    questionId: "",
    reset: false,
    soundStatus: true,
    selectedValue: '',
    soundPer: 0,
    volume: 90,
    correctFlag: true,
    resultObj: {},
    stopped: false,
    playbackSpeed: 1,
    soundKey: 0,
    question_audio: null,
    defaultSelectedVoice: null
  });

  const adjustWidth = (input) => {
    if (!input) return;
    const minWidth = 100;
    const tempSpan = document.createElement("span");
    tempSpan.style.visibility = "hidden";
    tempSpan.style.position = "absolute";
    tempSpan.style.whiteSpace = "pre";
    tempSpan.style.font = window.getComputedStyle(input).font;
    tempSpan.textContent = input.value || input.placeholder;

    document.body.appendChild(tempSpan);
    const newWidth = tempSpan.offsetWidth + 25;
    input.style.width = `${Math.max(newWidth, minWidth)}px`;

    document.body.removeChild(tempSpan);
  };

  const timer = () => {
    setState(prevState => {
      if (prevState.secondCount === 1) {
        clearInterval(intervalIdRef.current);
      }
      return { ...prevState, secondCount: prevState.secondCount - 1 };
    });
  };

  // const timerRecord = () => {
  //   setState(prevState => {
  //     if (prevState.recordCount === 40) {
  //       clearInterval(recordIdRef.current);
  //       stop();
  //     }
  //     return { ...prevState, recordCount: prevState.recordCount + 1 };
  //   });
  // };

  // const stop = () => {
  //   // Placeholder for stop function if needed
  // };

  const handleSongFinishedPlaying = () => {
    setState(prevState => ({ ...prevState, soundStatus: false }));
    props.soundChecked();
        if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const handleSongPlaying = (obj) => {
    setState(prevState => ({ ...prevState, soundPer: obj.position * 100 / obj.duration }));
  };

  const changeRange = (e) => {
    setState(prevState => ({ ...prevState, volume: e.target.value }));
  };

  const skip = () => {
    clearInterval(intervalIdRef.current);
    setState(prevState => ({ ...prevState, secondCount: 0 }));
  };

  const changePlaybackSpeed = (speed) => {
    setState(prevState => ({
      ...prevState,
      soundKey: prevState.soundKey + 1,
      playbackSpeed: speed
    }));
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId2Ref.current);

    intervalId2Ref.current = 0;

    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setState(prevState => ({
      ...prevState,
      question_audio: `${s3base}/${selected_audio[0].value}`
    }));
  };

  const handleChange = (event) => {
    props.showResult();
    let arr = [];
    [...document.querySelectorAll('.blankBox')].map((q) => { arr.push(q.value); });
    let correct = props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    props.submit({ 'answer': arr, 'correct': correct }, true);
    setState(prevState => ({ ...prevState, resultObj: { 'answer': arr, 'correct': correct } }));
  };

  const updateCorrect = () => {
    let correct = props.data.question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    props.submit({ 'answer': [], 'correct': correct });
    setState(prevState => ({ ...prevState, correctFlag: false, resultObj: { 'answer': [], 'correct': correct } }));
  };

  const showAnswer = () => {
    if (!props.resultMode) {
      let elem = document.querySelectorAll('.checkedSign');
      for (var i = 0; i <= elem.length - 1; i++) {
        let id = elem[i].dataset.id;

        if (elem[i].dataset.text.trim() == document.getElementById(id).value.trim()) {
          elem[i].innerHTML = '<i className="fa fa-check" style="font-size:32px;color:green"></i>';
        } else {
          elem[i].innerHTML = '<i className="fa fa-times" style="font-size:32px;color:red"></i>';
        }
      }
    }
  };

  // const stopTest = () => {
  //   props.nextQuestion(state.resultObj);
  // };

  const playingQuestionSectionLabel = () => {
    const { isRecording, secondCount, soundStatus, blobURL } = state;
    let status = '';
      if (props.answer) {
    return 'Question audio finished.';
  }
    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        status = `Beginning in ${state.secondCount} seconds`;
      } else if (secondCount === 0 && soundStatus) {
        status = 'Playing question audio...';
      } else {
        status = 'Question audio finished.'; // just any case.
      }
    } else {
      status = 'Question audio finished.';
    }
    return status;
  };

  const showSkipAudioWaitButton = () => {
    const { secondCount, blobURL, isRecording } = state;
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount !== 0 && blobURL === '' && !isRecording) {
      button = true;
    }

    return button;
  };
  
  const showSkipAudioButton = () => {
     const { secondCount, blobURL, isRecording,soundStatus } = state;
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount === 0 && soundStatus === true && !isRecording) {
      button = true;
    }

    return button;
  };

    const stopAudio = () => {
    // setSoundStatus(false);
      setState(prevState => ({ ...prevState, soundStatus: false }));
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const playAudio = () => {
    const { data, resultMode } = props;
    const { soundStatus, secondCount } = state;

    let audio = false;
    if (data && !resultMode && soundStatus && secondCount === 0) {
      audio = true;
    }

    return audio;
  };

  const renderAnswer = (response_index) => {
    const { answer, correct } = state.resultObj;
    const i = (response_index - 1) / 2;
    const correct_answer = correct[i];
    const user_answer = answer[i];

    let fill_text = "";
    if (user_answer === "") {
      fill_text = correct_answer;

    } else if (user_answer === correct_answer) {
      fill_text = user_answer;

    } else { // this is extran condition in case we want to render question mark with wrong answer.
      fill_text = user_answer;

    }

    return fill_text;
  };

  const answerStatusClass = (response_index) => {
    let class_name = "";
    if (props.answer) {
      const { answer, correct } = state.resultObj;

      const i = (response_index - 1) / 2;
      const correct_answer = correct[i].trim();
      const user_answer = answer[i];

      // const user_selected = answer[item] && answer[item].trim();

      if (user_answer === "") {
        class_name = "empty cursor-pointer"; // left blank by user.
      } else if (user_answer.trim() === correct_answer.trim()) {
        class_name = "correct"; // correct response.
      } else {
        const emptyAnswerClass = user_answer.trim() === "" ? " empty-answer" : "";
      class_name = `wrong q-mark cursor-pointer${emptyAnswerClass}`; // wrong response.
      }
    }

    return class_name;
  };

  const showCorrectAlongWithWrong = (index) => {
    let html = "";

    if (props.answer) {
      const { answer, correct } = state.resultObj;
      const i = (index - 1) / 2;
      const correct_answer = correct[i].trim();
      const user_answer = answer[i];

      if (user_answer !== "" && user_answer.trim() !== correct_answer.trim()) {
        html = (
          <span className="wrong-answer-correction">
            <i className="fa fa-long-arrow-right"></i>
            <span className="span11 correct-inverse text-center">{correct_answer}</span>
          </span>
        );
      }
    }

    return html;
  };

  // Initial mount effect
  useEffect(() => {
    if (inputRef.current) {
      adjustWidth(inputRef.current);
    }
    if (!props.answer) {
      // select audio.
      let question_audio = null;
      let defaultSelectedVoice = null;

      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoice = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      const newIntervalId = setInterval(timer, 1000);
      intervalIdRef.current = newIntervalId;
      
      setState(prevState => ({
        ...prevState,
        intervalId: newIntervalId,
        question_audio,
        defaultSelectedVoice
      }));

      // Call updateQuestionAudioUrlInPractice after state is set
      setTimeout(() => {
        props.updateQuestionAudioUrlInPractice(question_audio);
      }, 0);
    }

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  // Update effect for adjustWidth
  useEffect(() => {
    if (inputRef.current) {
      adjustWidth(inputRef.current);
    }
  });

  // Effect to handle props changes (getDerivedStateFromProps replacement)
  useEffect(() => {
    if (props.data) {
      if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        let question_audio = null;
        let defaultSelectedVoice = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoice = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        [...document.querySelectorAll('.blankBox')].map((q) => { q.value = ""; });
        setState(prevState => ({
          ...prevState,
          correctFlag: true,
          recordCount: 0,
          soundPer: 0,
          isRecording: false,
          secondCount: 10,
          questionId: props.data.id,
          blobURL: '',
          reset: true,
          soundStatus: true,
          question_audio,
          defaultSelectedVoice
        }));
      } else {
        if (!state.questionId) {
          setState(prevState => ({ ...prevState, correctFlag: true, questionId: props.data.id }));
        }
      }
    }
  }, [props.data, props.restart, state.questionId]);

  // Effect to handle reset
  useEffect(() => {
    if (state.reset) {
      const newIntervalId = setInterval(timer, 1000);
      intervalIdRef.current = newIntervalId;
      setState(prevState => ({ ...prevState, intervalId: newIntervalId, reset: false }));
    }
  }, [state.reset]);

  // let question = "";
  let question = useMemo(() => {
          return props.data?.question || "";
        }, [props.data?.question]); 
  

  let correct = "";

  // if (props.restart) {
  //   props.restartQue();
  // }

   useEffect(() => {
            if (props.restart) {
              props.restartQue();
            }
          }, [props.restart]);

           useEffect(() => {
                    if (props.answer) {
    showAnswer();
  }
                  }, [props.answer]);
  
  // if (props.answer) {
  //   showAnswer();
  // }

  // if (props.stopRecording) {
  //   stopTest();
  // }

  /**
  * IMPORTANT
  * 1. in case of timeout secondCount condition will work.
  * 2. in case of next button clicked by user ELSE IF condition will work.
  */
  // console.log('secondcount::', props.secondCount);
  // if (!state.stopped && props.secondCount === 1) {
  //   console.log('secondcount == 1');
  //   setState(prevState => ({ ...prevState, stopped: true }), () => {
  //     console.log('Stopping test by secondCount');
  //     stopTest();
  //   });
  // } else if (!state.stopped && props.stopRecording) {
  //   console.log('stopRecording');
  //   setState(prevState => ({ ...prevState, stopped: true }), () => {
  //     console.log('Stopping test by stopRecording');
  //     stopTest();
  //   });
  // }
  /** ----------------------------------------------------------------- */

  // if (props.data) {
  //   question = props.data.question;
  //   correct = question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
  //   if (state.correctFlag) {
  //     updateCorrect();
  //   }
  // }

  useEffect(() => {
              if (props.data) {
    question = props.data.question;
    correct = question.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
    if (state.correctFlag) {
      updateCorrect();
    }
  }
        }, [props.data, state.correctFlag]);

  const { data, resultMode, answer } = props;

  return (
    <>
      {playAudio() &&
        <Sound
          url={state.question_audio}
          playStatus={answer || !props.soundStatusMain ? Sound.status.STOPPED : Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onPlaying={handleSongPlaying}
          volume={state.volume}
          playbackRate={state.playbackSpeed}
          key={state.soundKey}
        />
      }

      <div className="pmw-tabs-section d-flex align-items-start justify-content-center pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible mx-0">
        {/* <div className="recorded-section h-100 width-25" width-50></div> */}
        <div className="recorded-section h-100 ">
          <div className="recorded-content">
            <div className="row">
              <div className="col-12">
                <ul className="recorded-list">
                  <li>Status:</li>
                  <li>{playingQuestionSectionLabel()}</li>
                </ul>
              </div>

                {/* <div className="col-4"> <span className="volume-label">Volume</span> </div>*/}
            </div>

            <div className="recorded-audio-wrapper">
              <div className="mt-3 clearfix">
                <div className="row">
                  <div className="col-10 col-sm-11">
                    <ProgressBar now={(state.soundPer)} striped />
                  </div>
                  <div className="col-1">
                    <div className="volume-control-wrapper">
                      <span className="volume-icon">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                      </span>
                      <div className="re-volume-wrapper-horizontal">
                        <input
                          type="range"
                          placeholder="Volume"
                          className="volume-control"
                          min="0"
                          max="100"
                          step="1"
                          defaultValue={state.volume}
                          onInput={changeRange}
                          style={{
                            "--progress": `${(state.volume / 100) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mt-2">
                    <div className="pull-left visibility-visible">
                      <PlaybackSpeedBtns
                       answer={props.answer}
                        sound = {state.soundStatus}
                        changePlaybackSpeed={changePlaybackSpeed}
                        playbackSpeed={state.playbackSpeed}
                      />
                    </div>

                    {state.defaultSelectedVoice !== null &&
                      <div className="mx-2 pull-left visibility-visible">
                        <SelectVoiceDropDown
                        answer={props.answer}
                        sound={state.soundStatus}
                        voices={props.voices}
                        selected={state.defaultSelectedVoice}
                        changeAudio={changeAudio}
                        />
                      </div>
                    }

                    {showSkipAudioWaitButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={skip}
                        >Start Audio</a>
                      </div>
                    }

                    {showSkipAudioButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={stopAudio}
                        >Stop Audio</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom-box mx-0">
        <div className="ice-storm-form">
          {data && !resultMode && reactStringReplace(question.replace(/<[^>]*>?/gm, 'x_x').replace(/x_x(.*?)x_x/g, ''), /(__add_blank__)/g, (match, i, o) => (
            <React.Fragment key={i}>
              {!answer ? (
                <input
                  type="text"
                  id={i}
                  spellCheck="false"
                  autoComplete="off"
                  onChange={(e) => {
                    handleChange(e);
                    adjustWidth(e.target);
                  }}
                  className="blankBox form-control auto-expand-input"
                  ref={(el) => (inputRef.current = el)}
                />
              ) : (
                <>
                  <div
                     style={{cursor :"pointer" , textDecorationLine:"none"}}
                    className={`span11 text-center ${answerStatusClass(i)}`}
                  >
                    {renderAnswer(i)}
                  </div>
                  {showCorrectAlongWithWrong(i)}
                </>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default ListeningBlank;
